import React, { useState } from "react";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import HourglassFullTwoToneIcon from "@mui/icons-material/HourglassFullTwoTone";
import NewReleasesIcon from "@mui/icons-material/NewReleases";
import { useLocation, Navigate } from "react-router-dom";
import PaymentHeader from "components/PaymentHeader";
import { useEffect } from "react";
import { getPaymentConfirmationDetails } from "store/actions";
import {
  displayAddress,
  displayCost,
  displayDateFormatter,
} from "components/helper";
import { Fragment } from "react";
import { CircularProgress } from "@mui/material";

const DisplayIcon = ({ message }) => {
  switch (message) {
    case status.success:
      return <ThumbUpIcon style={{ color: "green" }} />;
    case status.failed:
      return <NewReleasesIcon style={{ color: "red" }} />;
    case status.wentWrong:
      return <NewReleasesIcon style={{ color: "red" }} />;
    case status.inProcess:
      return <HourglassFullTwoToneIcon style={{ color: "#ffba01" }} />;
    default:
      return null;
  }
};

const status = {
  success: "Payment succeeded!",
  failed: "Your payment is processing.",
  inProcess: "Your payment was not successful, please try again.",
  wentWrong: "Your payment was not successful, please try again.",
};

const PaymentChargeEntryResultTable = ({ invoiceDetails }) => {
  return (
    <table className="charge-entry-table">
      <thead>
        <tr>
          <th>DOS</th>
          <th>Total Billed</th>
          <th>Insurance Adjusted / Paid</th>
          <th>Your Responsibility</th>
          <th>Paid</th>
        </tr>
      </thead>
      <tbody>
        {invoiceDetails.map((inv) => {
          return (
            <Fragment key={inv.charge_entry_id}>
              <tr>
                <td>{displayDateFormatter(inv.service_date)}</td>
                <td>{displayCost(inv.billed_amount)}</td>
                <td>{displayCost(inv.paid_adj_amount)}</td>
                <td>{displayCost(inv.patient_paid_amount)}</td>
                <td>{displayCost(inv.patient_paid_amount)}</td>
              </tr>
              <tr>
                <td colSpan={5}>
                  <table className="full-width charge-line-table">
                    <thead>
                      <tr>
                        <th>Charge Lines</th>
                        <th>DOS</th>
                        <th>Procedure Code</th>
                        <th>Description</th>
                        <th>Billed Amount</th>
                        <th>Remaining Balance</th>
                      </tr>
                    </thead>
                    <tbody>
                      {inv.charges.map((cl, index) => (
                        <tr key={cl.procedure_code}>
                          <td>{index + 1}</td>
                          <td>{displayDateFormatter(cl.service_date_from)}</td>
                          <td>{cl.procedure_code}</td>
                          <td>{cl.description}</td>
                          <td>{displayCost(cl.charge_amt)}</td>
                          <td>{displayCost(0)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </td>
              </tr>
            </Fragment>
          );
        })}
      </tbody>
    </table>
  );
};

const StripeResult = ({ message, state }) => {
  const [loading, setLoading] = useState(false);
  const [invoiceDetails, setInvoiceDetails] = useState([]);
  const [patientData, setPatientData] = useState({});
  const [paymentData, setPaymentData] = useState({});
  const [error, seterror] = useState("");

  useEffect(() => {
    const getInvoiceData = async () => {
      setLoading(true);
      const response = await getPaymentConfirmationDetails({
        bill_account_number: state.invoice_number,
        practice_id: state.practice_id,
        patient_id: state.patient_id,
      });
      if (response) {
        setInvoiceDetails(response.invoice_data);
        setPatientData(response.patient_data);
        setPaymentData(response.payment_data);
      } else {
        seterror("Payment details not found");
      }
      setLoading(false);
    };
    if (state?.invoice_number) getInvoiceData();
  }, [state.invoice_number, state.patient_id, state.practice_id]);

  if (!state) return null;
  console.log({ state });
  return (
    <div className="payment-result">
      <PaymentHeader resultPage={true} source={state.source} />
      <div className="payment-success">
        <div className="main">
          <>
            {/* <h1>{message} </h1> */}
            <h1>Payment Receipt</h1>
            {loading ? (
              <CircularProgress color="secondary" className="margin-center " />
            ) : error ? (
              <p className="error-msg">{error}</p>
            ) : (
              <>
                {state?.invoice_number ? (
                  <p className="invoice">
                    Invoice Number: {state.invoice_number}
                  </p>
                ) : null}
                <DisplayIcon fontSize="large" message={message} />
                <div>
                  Patient Name:{" "}
                  <strong>
                    {" "}
                    {(patientData?.first_name || "") +
                      " " +
                      (patientData?.last_name || "")}
                  </strong>
                  <br />
                  Address: <strong> {displayAddress(patientData)}</strong>
                  <br />
                  Confirmation:{" "}
                  <strong> {paymentData.confirmation_no || "N/A"}</strong>
                  <br />
                  Paid Date:{" "}
                  <strong>
                    {" "}
                    {displayDateFormatter(paymentData.transaction_date)}
                  </strong>
                </div>
                <PaymentChargeEntryResultTable
                  invoiceDetails={invoiceDetails}
                />

                <button
                  to="/dashboard"
                  className="blank-hover-btn"
                  onClick={() => window.print()}
                >
                  Print
                </button>
              </>
            )}
          </>
        </div>
      </div>
    </div>
  );
};

const PaymentResult = () => {
  const [loading, setLoading] = useState(false);
  const { state } = useLocation();
  if (!state) return <Navigate to="/payment" />;
  if (state) {
    return (
      <>
        <StripeResult
          loading={loading}
          setLoading={setLoading}
          state={state}
          message={"Payment succeeded!"}
        />
      </>
    );
  }
};

export default PaymentResult;
